import { Badge } from '@shopify/polaris'
import React from 'react'

export const WorkflowStatusBadge = ({ data }: { data: { is_active: boolean } }) => (
  <Badge tone={data.is_active ? 'success' : 'warning'}>
    {data.is_active ? 'Active' : 'Disabled'}
  </Badge>
)
